import template from './degreeModal.html';
import controller from './degreeModal.controller';

let DegreeModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default DegreeModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/degreeModal/degreeModal.component.js